"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateResultComponent = CalculateResultComponent;
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const DownloadResultSelectorComponent = __importStar(require("./download-result-selector"));
const Actions = __importStar(require("../../actions"));
const results_table_1 = require("./results-table");
function CalculateResultComponent(props) {
    const onClose = () => props.dispatch(Actions.setPropertiesCoilproDownloadSelector(undefined));
    const onItemsChange = (state) => props.dispatch(Actions.setPropertiesCoilproDownloadSelector(state));
    return (React.createElement(Elements.StandardContainer, null,
        React.createElement(Elements.InnerContainer, null,
            props.popupDownloadSelector && (React.createElement(DownloadResultSelectorComponent.DownloadResultSelectorComponent, { top: props.popupDownloadSelector.top, left: props.popupDownloadSelector.left, onClose: () => onClose(), items: props.popupDownloadSelector.items, onItemsChange: items => onItemsChange(Object.assign(Object.assign({}, props.popupDownloadSelector), { items: items })), results: props.results })),
            React.createElement(Elements.StandardButton, { onClick: e => {
                    const boundClientRect = e.target.getBoundingClientRect();
                    props.dispatch(Actions.setPropertiesCoilproDownloadSelector({
                        left: boundClientRect.left,
                        top: boundClientRect.top,
                        items: props.resultDefinitions
                            .map(x => x.propertyName)
                            .reduce((soFar, current) => (Object.assign(Object.assign({}, soFar), { [current]: true })), {})
                    }));
                } }, "Download")),
        React.createElement(Elements.FlexContainerRowWithPadding, null,
            React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.InnerContainer, null,
                    React.createElement(Elements.H3, null, "Results"),
                    React.createElement(results_table_1.ResultsTable, { results: props.results, resultDefinitions: props.resultDefinitions }))),
            props.results.filter(r => r.error !== undefined).length > 0 ? (React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.H3, null, "Errors"),
                props.results.length === 1 ? (React.createElement("div", null, props.results[0].error)) : (props.results.map((r, ix) => r.error && (React.createElement("div", { key: ix },
                    "Case #",
                    ix + 1,
                    ": ",
                    r.error)))))) : null)));
}
//# sourceMappingURL=container-component.js.map